export const PRICING = {
    default: {
        monthly: {
            description: "Use Interview Copilot for 6 Sessions each month.",
            title: "6 Copilot Sessions Each Month",
            item: "Interview Copilot® (60 Minutes/Session)"
        },
        payPerUse: {
            title: "Get 1 Copilot Session instantly",
            item: "Interview Copilot® (60 Minutes)"
        },
        quarterly: {
            description: "Use Interview Copilot for 18 Sessions each quarter.",
            title: "18 Copilot Sessions every 3 month",
            item: "Interview Copilot® (60 Minutes/Session)"
        }
    },
    assistant: {
        monthly: {
            description: "Use AI Assistant for 6 Sessions each month.",
            title: "6 Assistant Sessions Each Month",
            item: "AI Assistant® (60 Minutes/Session)"
        },
        payPerUse: {
            title: "Get 1 Assistant Session instantly",
            item: "AI Assistant® (60 Minutes)"
        },
        quarterly: {
            description: "Use AI Assistant for 18 Sessions each quarter.",
            title: "18 Assistant Sessions every 3 month",
            item: "AI Assistant® (60 Minutes/Session)"
        }
    }
};
